/**
 * ORIN — Shared constants
 *
 * Single source of truth for enum values used across the app.
 * Keep these in sync with the Postgres CHECK constraints in Supabase.
 */

// ----------------------------------------------------------------
// Departments (BIT 4)
// ----------------------------------------------------------------
export const DEPARTMENTS = Object.freeze({
  COMMUNICATION: 'Communication',
  CREATIVE: 'Creative',
  PRODUCTION: 'Production',
  ADMIN: 'Admin',
  HR: 'HR',
});

export const DEPARTMENT_LIST = Object.freeze([
  DEPARTMENTS.COMMUNICATION,
  DEPARTMENTS.CREATIVE,
  DEPARTMENTS.PRODUCTION,
  DEPARTMENTS.ADMIN,
  DEPARTMENTS.HR,
]);

export const DEPARTMENT_COLORS = Object.freeze({
  [DEPARTMENTS.COMMUNICATION]: '#2563EB',
  [DEPARTMENTS.CREATIVE]: '#7C3AED',
  [DEPARTMENTS.PRODUCTION]: '#EA580C',
  [DEPARTMENTS.ADMIN]: '#0891B2',
  [DEPARTMENTS.HR]: '#16A34A',
});

// ----------------------------------------------------------------
// Designations (registration). Org-wide designations don't belong
// to a department, so department becomes optional for them.
// ----------------------------------------------------------------
export const DESIGNATIONS = Object.freeze([
  'Founder',
  'Co-Founder',
  'Manager',
  'Team Leader',
  'Executive',
  'Team Member',
  'Intern',
]);

export const DEPT_OPTIONAL_DESIGNATIONS = Object.freeze(['Founder', 'Co-Founder']);

export function isDeptOptionalDesignation(designation) {
  return DEPT_OPTIONAL_DESIGNATIONS.includes(designation);
}

// ----------------------------------------------------------------
// Standard time presets (TL+ can override at task creation)
// ----------------------------------------------------------------
export const STD_TIME_OPTIONS = Object.freeze([15, 30, 45, 60, 75]);

// ----------------------------------------------------------------
// Task status (BIT 8) — must match Postgres CHECK on tasks.status
// ----------------------------------------------------------------
export const TASK_STATUS = Object.freeze({
  TODO: 'todo',
  IN_PROGRESS: 'in_progress',
  DONE: 'done',
  OVERDUE: 'overdue',
  REDO: 'redo',
});

export const TASK_STATUS_LABELS = Object.freeze({
  todo: 'To Do',
  in_progress: 'In Progress',
  done: 'Done',
  overdue: 'Overdue',
  redo: 'Redo',
});

export const TASK_STATUS_COLORS = Object.freeze({
  todo: '#6B7280',
  in_progress: '#2563EB',
  done: '#16A34A',
  overdue: '#DC2626',
  redo: '#D97706',
});

// ----------------------------------------------------------------
// Priority (BIT 6) — must match Postgres CHECK on tasks.priority
// ----------------------------------------------------------------
export const PRIORITY = Object.freeze({
  LOW: 'low',
  MEDIUM: 'medium',
  HIGH: 'high',
});

export const PRIORITY_LABELS = Object.freeze({
  low: 'Low',
  medium: 'Medium',
  high: 'High',
});

// ----------------------------------------------------------------
// User account status (BIT 11) — must match CHECK on users.status
// ----------------------------------------------------------------
export const USER_STATUS = Object.freeze({
  ACTIVE: 'active',
  PENDING: 'pending',
  DISABLED: 'disabled',
});

// ----------------------------------------------------------------
// Doubt status — must match CHECK on doubts.status
// ----------------------------------------------------------------
export const DOUBT_STATUS = Object.freeze({
  OPEN: 'open',
  RESOLVED: 'resolved',
});

// ----------------------------------------------------------------
// Brand
// ----------------------------------------------------------------
export const APP = Object.freeze({
  NAME: 'ORIN',
  COMPANY_SHORT: 'ENEPL',
  COMPANY_FULL: 'Entre Nous Experiences',
});